module.exports = __webpack_public_path__ + "img/thinkvmscreenshot.6249e26f.png";